// extracted by mini-css-extract-plugin
export var errorIcon = "_of-1";
export var nameLogo = "_of-0";